export default __webpack_public_path__ + "static/media/cripplingweakness.26007fb0.png";